export enum PaymentFlow {
  START_OF_CYCLE = 'START_OF_CYCLE',
  END_OF_CYCLE = 'END_OF_CYCLE'
}
